export default "__VITE_ASSET__DKEzUJn5__"